import classNames from 'classnames';
import { RefreshCw, TriangleAlert } from 'lucide-react';
import { Button } from '../Button';
import { Flex } from '../Flex';
import { Icon } from '../Icon';
import type { SharedComponentProps } from '../types';
import * as styles from './index.css';

const DEFAULT_MESSAGE = 'データの取得に失敗しました。';

type ErrorOverlayProps = SharedComponentProps<'div'> & {
    /** Whether the retry prompt replaces `children` while `active`. */
    active: boolean;
    /** Omit when there's nothing to retry — the button is hidden instead of a no-op. */
    onRetry?: () => void;
    message?: string;
};

/** Replaces `children` with a retry prompt while `active` — there's nothing meaningful
 * to show behind a hard failure, unlike `Skeleton.Overlay`'s dimmed-content approach. */
export function ErrorOverlay({
    active,
    onRetry,
    message = DEFAULT_MESSAGE,
    children,
    className,
    style,
    ...props
}: ErrorOverlayProps) {
    if (!active) return <>{children}</>;

    return (
        <div className={classNames(styles.notice, className)} style={style} {...props}>
            <Flex direction="column" align="center" gap="3">
                <Icon icon={TriangleAlert} size="lg" className={styles.icon} />
                <p className={styles.message}>{message}</p>
                {onRetry && (
                    <Button variant="secondary" onClick={onRetry}>
                        <Icon icon={RefreshCw} size="sm" />
                        再試行
                    </Button>
                )}
            </Flex>
        </div>
    );
}
